export default (theme) => ({
  container: {
    padding: 5,
    background: "#EBEBEB",
    minWidth: 130,
    borderRadius: 4,
  },
});
